import React from "react";
import CountUp from "react-countup";
import TrackVisibility from "react-on-screen";
import ScrollAnimation from "react-animate-on-scroll";

const Data = [
  {
    countNum: 199,
    countTitle: "Happy Clients.",
  },
  {
    countNum: 575,
    countTitle: "Employees",
  },
  {
    countNum: 69,
    countTitle: "Useful Programs",
  },
  {
    countNum: 500,
    countTitle: "Useful Programs",
  },
];

const SlipTwo = () => {
  return (
    <div className="rn-splite-style">
      <div className="split-wrapper container">
        <div className="row no-gutters radius-10 align-items-center">
          <div className="col-lg-12 col-xl-4 col-12">
            <div className="thumbnail">
              <img src="./image//split/split.jpg" alt="split Images" />
            </div>
          </div>
          <div className="col-lg-12 col-xl-8 col-12">
            <div className="split-inner">
              <ScrollAnimation
                animateIn="fadeInUp"
                animateOut="fadeInOut"
                animateOnce={true}
              >
                <h4 className="title">Continue Your Business With Us.</h4>
              </ScrollAnimation>
              <ScrollAnimation
                animateIn="fadeInUp"
                animateOut="fadeInOut"
                animateOnce={true}
              >
                <p className="description">
                  At WhatsOn Agency, we are committed to supporting your
                  business's growth and success. With a proven track record of
                  delivering exceptional results, we provide innovative digital
                  solutions tailored to your unique needs.
                </p>
              </ScrollAnimation>

              <div className="row">
                {Data.map((data, index) => (
                  <div
                    className="col-lg-6 col-md-6 col-sm-6 col-12"
                    key={index}
                  >
                    <div className="count-box counter-style-4 text-start">
                      <TrackVisibility once>
                        {({ isVisible }) =>
                          isVisible && (
                            <div className="count-number">
                              {isVisible ? <CountUp end={data.countNum} /> : 0}
                            </div>
                          )
                        }
                      </TrackVisibility>
                      <h5 className="counter-title">{data.countTitle}</h5>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SlipTwo;
